import { render } from "./Login.vue?vue&type=template&id=3b6adb30"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/Login.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b6adb30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b6adb30', __exports__)) {
    console.log('reload')
    api.reload('3b6adb30', __exports__)
  }
  
  module.hot.accept("./Login.vue?vue&type=template&id=3b6adb30", () => {
    console.log('re-render')
    api.rerender('3b6adb30', render)
  })

}


export default __exports__